import BuildIcon from '@mui/icons-material/Build';
import StepList from './StepList';

export default {
      list: StepList,
      icon: BuildIcon,
}